'use client'

import { useEffect } from 'react'

declare global {
    interface Window {
        ayManagerEnv: any
        assertive: any
        googlefc: any
        __tcfapi: any
    }
}

const AssertiveYield: React.FC = () => {
    useEffect(() => {
        // GDPR Compliance
        window.googlefc = window.googlefc || {}
        window.googlefc.callbackQueue = window.googlefc.callbackQueue || []

        window.assertive = {
            debug: true,
            entityId: 'y54F5Ku6eTSmA2cwk',
            analytics: {
                integrations: {
                    webAnalytics: true,
                    ima: true,
                    taboola: true,
                },
                logUnfilled: true,
                custom: {
                    layout: null,
                    userState: null,
                    custom_1: null,
                    custom_2: null,
                    custom_3: null,
                    custom_4: null,
                    custom_5: null,
                    custom_6: null,
                    custom_7: null,
                    custom_8: null,
                    custom_9: null,
                    custom_10: null,
                    custom_11: null,
                    custom_12: null,
                    custom_13: null,
                    custom_14: null,
                    custom_15: null,
                },
            },
        }

        const script = document.createElement('script')
        script.src = 'https://y54F5Ku6eTSmA2cwk.ay.delivery/client-v2.js'
        script.async = true

        const script2 = document.createElement('script')
        script2.src = 'https://y54F5Ku6eTSmA2cwk.ay.delivery/manager/y54F5Ku6eTSmA2cwk'
        script2.async = true

        // Only load AY after consent available
        window.googlefc.callbackQueue.push({
            CONSENT_DATA_READY: () =>
                window.__tcfapi('addEventListener', 2.2, (_data: any, _success: any) => {
                    document.head.appendChild(script)
                    document.head.appendChild(script2)
                }),
        })

        return () => {
            document.head.removeChild(script)
            document.head.removeChild(script2)
        }
    }, [])

    return null
}

export default AssertiveYield
